export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-r from-[#2D3748] to-[#1A1625] overflow-hidden">
      {/* Top gradient border */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-[#FF6B6B] via-[#6B5FFF] to-[#FF6B6B] opacity-30" />

      {/* Subtle paw print pattern */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none">
        <div className="absolute top-8 left-[10%] text-3xl">🐾</div>
        <div className="absolute top-12 right-[15%] text-2xl">🐾</div>
        <div className="absolute bottom-8 left-[20%] text-2xl">🐾</div>
        <div className="absolute bottom-10 right-[25%] text-3xl">🐾</div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-6">
          {/* Left: Logo */}
          <div className="flex items-center justify-center md:justify-start gap-3">
            <img 
              src="https://static.readdy.ai/image/45ee86dea452076dc7a3c34b683d6864/01dcf18c52005850bee6e4aa29548a07.png" 
              alt="Bor Studio Logo" 
              className="h-8 w-8 object-contain"
            />
            <span className="text-2xl font-bold text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.3)]">
              Bor Studio
            </span>
          </div>

          {/* Center: Copyright */}
          <div className="flex justify-center">
            <p className="text-sm text-[#A0AEC0] text-center">
              © 2026 Bor Studio – Incubating Pet Startups in Asia
            </p>
          </div>

          {/* Right: Social Links */}
          <div className="flex items-center justify-center md:justify-end gap-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center text-white hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
          </div>
        </div>

        {/* Readdy Link */}
        <div className="mt-8 text-center">
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#A0AEC0] hover:text-white transition-colors duration-300 cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}